import React, { useState } from "react";
import PropTypes from "prop-types";

import { DROP_SVG } from "../../../../../constants/svgConstants";
import SubscriptionCardMobile from "../SubscriptionCardsBlock/SubscriptionCardMobile";

function SubscriptionSearchBlockMobile({
  ListOfItems,
  activeTitle,
  changeActiveId,
  allCards,
  cardOpenPriceEnabled,
}) {
  const [showDropMenu, setShowDropMenu] = useState(false);

  return (
    <>
      <div className="subscription__mobile-search-block">
        <div
          onClick={() => {
            setShowDropMenu(!showDropMenu);
          }}
          className={
            showDropMenu
              ? "subscription__mobile-search-active-block subscription__mobile-search-active-block_active"
              : "subscription__mobile-search-active-block"
          }
        >
          {activeTitle ? activeTitle : "Все"}
          {DROP_SVG}
          {showDropMenu && (
            <div className="subscription__mobile-search-dropdown-block">
              <div className="subscription__mobile-search-dropdown-wrapper">
                {ListOfItems.map(({ id, title }) => (
                  <div
                    key={id}
                    className="subscription__mobile-search-dropdown-el"
                    onClick={() => {
                      changeActiveId(id);
                      setShowDropMenu(false);
                    }}
                  >
                    {title}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        <div className="subscription-cards-block subscription-card-mobile-wrapper">
          {allCards.map(({ id, buttonFunc: cardFunc, ...props }) => {
            return (
              <SubscriptionCardMobile
                {...{
                  ...props,
                  id: +id,
                  isSubscription: false,
                  cardOpenPriceEnabled,
                }}
                key={id}
              />
            );
          })}
        </div>
      </div>
    </>
  );
}

SubscriptionSearchBlockMobile.propTypes = {
  ListOfItems: PropTypes.array,
  activeTitle: PropTypes.string,
  changeActiveId: PropTypes.func,
};

SubscriptionSearchBlockMobile.defaultProps = {
  ListOfItems: [],
  activeTitle: "",
  changeActiveId: () => {},
};

export default SubscriptionSearchBlockMobile;
